// extracted by mini-css-extract-plugin
export default {"Star":"Feedbacks_Star__84bgb"};